import { loadingStart, loadingStop } from '../actions/loadingState';
import { call, put } from 'redux-saga/effects';
import Products from '../services/api/Products';
import {
    productsCounterFetched,
    productsFetched,
    productsFetchedFailure,
} from '../actions/masterTable';
import {
    toggleProductFavorite,
    fetchProductDeliveryWeeks,
} from '../actions/routines';

export function* toggleProductFavouriteSaga(action) {
    try {
        yield put(toggleProductFavorite.request());

        const response = yield call(Products.toggleFavourite, action.payload);

        yield put(toggleProductFavorite.success(response.data));
    } catch (error) {
        yield put(toggleProductFavorite.failure(error.message));
    } finally {
        yield put(toggleProductFavorite.fulfill());
    }
}

export function* fetchProductsSaga(action) {
    yield put(loadingStart());

    let lastResponse = { data: [], headers: {} };

    try {
        const response = yield call(Products.getProducts, action.data);

        const currentPage = parseInt(response.headers['x-current-page']);

        lastResponse.data = response.data;
        lastResponse.headers = response.headers;

        yield put(
            productsFetched({
                products: response.data,
                hasMyList: response.headers['x-has-my-list'],
                hasMore: !!+response.headers['x-has-more'],
                currentPage: currentPage > 0 ? currentPage : 1,
            })
        );
    } catch (err) {
        yield put(productsFetchedFailure(err.message));
    }
    yield put(loadingStop());
    //
    try {
        // fetch delivery
        if (lastResponse.data && lastResponse.data.length > 0) {
            const productIds = lastResponse.data.map((product) => product.id);
            yield put(fetchProductDeliveryWeeks({ productIds }));
        }
        // fetch counters of products
        const responseCounter = yield call(
            Products.getProductsCounters,
            action.data
        );

        yield put(
            productsCounterFetched({
                total: parseInt(responseCounter.headers['x-total-count'] ?? 0),
                myTotal: parseInt(
                    responseCounter.headers['x-total-my-products-count'] ?? 0
                ),
                ksTotal: parseInt(
                    responseCounter.headers['x-total-ks-products-count'] ?? 0
                ),
                maSupplierTotal: parseInt(
                    responseCounter.headers['x-total-ma-supplier-count'] ?? 0
                ),
                myFavorite: parseInt(
                    responseCounter.headers['x-total-my-favorite-count'] ?? 0
                ),
                totalWithPromotionFilter: parseInt(
                    responseCounter.headers[
                        'x-total-with-promotion-filter-count'
                    ] ?? 0
                ),
                totalWithoutPromotionFilter: parseInt(
                    responseCounter.headers[
                        'x-total-without-promotion-filter-count'
                    ] ?? 0
                ),
                totalWithBonusDragend: parseInt(
                    responseCounter.headers['x-total-with-bonus-dragend'] ?? 0
                ),
                totalWithoutBonusDragend: parseInt(
                    responseCounter.headers['x-total-without-bonus-dragend'] ??
                        0
                ),
            })
        );
    } catch (err) {
        yield put(productsFetchedFailure(err.message));
    }
}
